import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { store } from './helpers';
import { RoutesRoot } from './routes';

import GlobalStyles from './Spread/styles/globalStyle';
import './Spread/styles/fonts.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
        <GlobalStyles />
        <RoutesRoot />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
